import React from 'react';
import {Text} from '@flixbus/honeycomb-react';
import {ReadOnlyInputProps} from './ReadOnlyInput.types';

const ReadOnlyInput: React.FC<ReadOnlyInputProps> = ({
  label,
  value,
  id,
  extraClasses,
  horizontal = false
}) => {
  return (
    <Text
      Elem="span"
      extraClasses={`${
        horizontal ? 'flex-row gap-half' : 'flex-col'
      } ${extraClasses}`}
    >
      <span aria-label={`${id}-label`}>{label}</span>
      <b aria-label={`${id}-value`}>{value}</b>
    </Text>
  );
};

export default React.memo(ReadOnlyInput);
